const INDEX_ITEMS = [
  { label: '明星八卦', icon: 'ri-star-line', count: 486, color: 'text-accent-500', bg: 'bg-accent-100' },
  { label: '综艺爆料', icon: 'ri-tv-line', count: 352, color: 'text-primary-500', bg: 'bg-primary-100' },
  { label: '恋情曝光', icon: 'ri-heart-line', count: 298, color: 'text-accent-500', bg: 'bg-accent-100' },
  { label: '影视圈', icon: 'ri-film-line', count: 267, color: 'text-primary-500', bg: 'bg-primary-100' },
  { label: '网红圈', icon: 'ri-live-line', count: 231, color: 'text-accent-500', bg: 'bg-accent-100' },
  { label: '音乐圈', icon: 'ri-music-line', count: 198, color: 'text-primary-500', bg: 'bg-primary-100' },
  { label: '时尚圈', icon: 'ri-shirt-line', count: 165, color: 'text-accent-500', bg: 'bg-accent-100' },
  { label: '吃瓜现场', icon: 'ri-camera-line', count: 312, color: 'text-primary-500', bg: 'bg-primary-100' },
  { label: '深度扒皮', icon: 'ri-search-eye-line', count: 143, color: 'text-accent-500', bg: 'bg-accent-100' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">瓜圈索引</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            按主题快速浏览，找到你最想吃的瓜圈分类
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {INDEX_ITEMS.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group flex items-center gap-3 p-4 md:p-5 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200/60 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl ${item.bg} flex-shrink-0`}>
                <i className={`${item.icon} ${item.color} text-lg md:text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-medium text-sm md:text-base text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {item.label}
                </div>
                <div className="text-xs text-foreground-500 mt-0.5">{item.count} 条视频</div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}